import { ContractType, StableKey } from './common-types'
import { DealDocumentTags, EntityDocumentTags } from './dropdown-options'
import { Hold } from './hold-params'

export type Document = {
  admin: string
  id: string
  tags: string[]
  documentType: string
  documentTypeText?: string
  mimeType: string
  name: string
  createDate: string
  contractId: StableKey
  contractType: ContractType
  signedBy?: string
}

export type SignerType = 'Buyer' | 'Seller' | 'Agent' | 'Reviewer'

export type SignerPartyWithType = {
  signerType: SignerType
  signerParty: string
  // The ledger stores signatures as SignerPartyInfo, so entries coming from a
  // signable document also carry who signed and when — the backend DTO just
  // types them narrowly. Optional because required-signature steps use the
  // same shape without them.
  userId?: string
  actionTime?: string
}

export type AdminSignedData = {
  signerPartyInfo: {
    signerType: SignerType
    signerParty: string
    userId: string
    actionTime: string
  }
  offlineSignedDocument: {
    documentId?: string
    createDate: string
  }
}

export type SignableDocument = {
  externalId: string
  documentType: string
  contractType: ContractType
  contractId: string
  contractAdmin: string
  requiredSignatures: { steps: any[] }
  signatures: SignerPartyWithType[]
  adminSignedFor: AdminSignedData[]
  observers: string[]
  url?: string
  // Live-rendered HTML for an unlocked Funding Memo (computed real-time, not a
  // persisted DocuSeal PDF). When set, the preview renders this instead of `url`.
  previewHtml?: string | null
  fileName?: string // Optional, used for file download from Docuseal
  createDate: string
  // When the document last CHANGED — every choice that modifies it stamps this
  // (signing, hold placed or lifted, regeneration), not just a refresh. Pair it
  // with createDate, which is the document's birth date and never moves. Null
  // until the first change after creation.
  refreshedAt?: string | null
  holds: Hold[]
}

export function getDocumentTagOptions(contractType: ContractType) {
  switch (contractType) {
    case ContractType.Deals:
    case ContractType.Facilities:
      return DealDocumentTags
    case ContractType.Entities:
      return EntityDocumentTags
    case ContractType.Principals:
    case ContractType.Payments:
      return []
    default:
      return []
  }
}
